module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "doTable__items text-dark"
  }, [(_vm.kindergartenCalendarsWithProps.length === 0) ? _c('h2', {
    staticClass: "text-explainer"
  }, [_vm._v("Ingen stuer oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.kindergartenCalendarsWithProps), function(calendar) {
    return _c('li', {
      key: calendar.id,
      staticClass: "doTable__klass"
    }, [_c('div', {
      staticClass: "doTable__klass__header"
    }, [_c('div', [_vm._v(_vm._s(calendar.name))]), _vm._v(" "), _c('div', [_c('button', {
      on: {
        "click": function($event) {
          return _vm.setIsCreate(calendar)
        }
      }
    }, [_vm._v("Opret brik på stuen")])])]), _vm._v(" "), _c('ul', {
      staticClass: "subjects"
    }, [(calendar.v_tasks_with_kids.length < 1) ? _c('h4', {
      staticClass: "text-explainer"
    }, [_vm._v("Ingen brikker oprettet")]) : _vm._e(), _vm._v(" "), _vm._l((calendar.v_tasks_with_kids), function(subject) {
      return _c('li', {
        key: subject.id,
        staticClass: "subjects_subject",
        style: ({
          'background': subject.color
        }),
        on: {
          "click": function($event) {
            return _vm.setEditSubject(subject)
          }
        }
      }, [_vm._v("\n          " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n        ")])
    })], 2)])
  }), _vm._v(" "), (_vm.isSubjectModal) ? _c('CreateSubjectForm', {
    attrs: {
      "showModal": _vm.isSubjectModal,
      "initCalendarId": _vm.activeCalendarId,
      "editSubject": _vm.theEditSubject,
      "editSubjectId": _vm.theEditSubjectId
    },
    on: {
      "close": _vm.closeSubjectModal,
      "createSubject": _vm.createNewSubject,
      "updateSubject": _vm.updateSubject,
      "deleteSubject": _vm.deleteSubject
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('AnnualNormWithoutKids', {
    attrs: {
      "isWithKids": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07b4aa4a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnnualNorm/AnnualNormWithKids.vue
// module id = 1746
// module chunks = 1